export default "__VITE_ASSET__CpCNGRIr__"